import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft, Printer } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function GraduationCertificate() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [trainee, setTrainee] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const { data: users } = await axios.get(`${API}/users`);
        const t = users.find(u => u.id === id);
        setTrainee(t);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [id]);

  if (loading) {
    return <div className="flex items-center justify-center h-64"><div className="w-6 h-6 border-2 border-[#0047FF] border-t-transparent animate-spin" /></div>;
  }

  return (
    <div data-testid="graduation-certificate-page" className="space-y-6">
      <div className="flex items-center gap-4 no-print">
        <button data-testid="cert-back-button" onClick={() => navigate(-1)} className="p-2 text-[#4B5563] hover:text-[#0A0A0A] transition-colors">
          <ArrowLeft size={20} />
        </button>
        <h1 className="font-heading text-2xl font-bold text-[#0A0A0A] tracking-tight">Graduation Certificate</h1>
        <Button data-testid="print-certificate-button" onClick={() => window.print()} variant="outline" className="rounded-none font-body gap-2 ml-auto">
          <Printer size={16} /> Print
        </Button>
      </div>

      <div className="flex justify-center">
        <div className="w-full max-w-3xl border-4 border-[#0A0A0A] p-12 bg-white relative">
          {/* Corner decorations */}
          <div className="absolute top-3 left-3 right-3 bottom-3 border border-[#E5E7EB]" />

          <div className="relative z-10 text-center space-y-8 py-8">
            <div>
              <p className="font-body text-xs uppercase tracking-[0.3em] text-[#4B5563] mb-2">Certificate of</p>
              <h2 className="font-heading text-4xl sm:text-5xl font-black text-[#0A0A0A] tracking-tighter">Graduation</h2>
            </div>

            <div className="w-16 h-0.5 bg-[#0047FF] mx-auto" />

            <div>
              <p className="font-body text-sm text-[#4B5563] mb-2">This is to certify that</p>
              <p className="font-heading text-3xl font-black text-[#0047FF] tracking-tight">{trainee?.name || 'Trainee'}</p>
            </div>

            <p className="font-body text-base text-[#4B5563] max-w-md mx-auto leading-relaxed">
              has successfully completed the 16-day Training Journey Program
              and is hereby confirmed for an ongoing operational role.
            </p>

            <div className="flex items-center justify-center gap-12 pt-4">
              <div className="text-center">
                <div className="w-32 border-b border-[#0A0A0A] mb-2" />
                <p className="font-body text-xs uppercase tracking-[0.2em] text-[#4B5563]">Date</p>
                <p className="font-body text-sm font-medium text-[#0A0A0A] mt-1">{new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
              </div>
              <div className="text-center">
                <div className="w-32 border-b border-[#0A0A0A] mb-2" />
                <p className="font-body text-xs uppercase tracking-[0.2em] text-[#4B5563]">VP - Operations</p>
              </div>
            </div>

            <p className="font-body text-xs text-[#4B5563] pt-8">Training Journey Portal</p>
          </div>
        </div>
      </div>
    </div>
  );
}
